import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { login } from '../redux/actions/auth';
import { useFormik } from 'formik';
import * as yup from 'yup';

import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import { Alert, AlertTitle } from '@mui/material';
import { CircularProgress } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Copyright from '../components/Copyright';
import ProjectTitle from '../components/ProjectTitle';

import BackgroundImage from '../assets/img/istanbul.png';

const validationsForm = yup.object({
  email: yup
    .string()
    .email('Lütfen geçerli bir e-mail giriniz.')
    .required('Email bilgisi gerekli.'),
  password: yup
    .string()
    .min(8, 'Parola en az 8 karakter içermelidir.')
    .required('Lütfen parolanızı giriniz.'),
});

const theme = createTheme();

const SignInPage = (props) => {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const { isLoggedIn } = useSelector((state) => state.auth);
  const { message } = useSelector((state) => state.authMessage);

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: validationsForm,
    onSubmit: (values) => {
      const { email, password } = values;
      setLoading(true);
      dispatch(login(email, password))
        .then(() => {
          props.history.push('/map');
          window.location.reload();
        })
        .catch(() => {
          setLoading(false);
        });
    },
  });

  if (isLoggedIn) {
    return <Navigate to="/map" />;
  }

  return (
    <ThemeProvider theme={theme}>
      <div
        style={{
          backgroundImage: `url(${BackgroundImage})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          minHeight: '100vh',
          border: '0.1px solid black',
        }}
      >
        <Grid
          container
          component="main"
          sx={{
            verticalAlign: 'center',
            marginTop: '5%',
            marginBottom: '5%',
            alignContent: 'center',
            alignItems: 'center',
            justifyContent: 'center',
            alignSelf: 'center',
          }}
        >
          <CssBaseline />
          <Grid
            item
            xs={12}
            sm={8}
            md={4}
            component={Paper}
            elevation={6}
            square
          >
            <Box
              sx={{
                my: 8,
                mx: 4,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <ProjectTitle />
              <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                <LockOutlinedIcon />
              </Avatar>
              <Typography component="h1" variant="h5">
                Oturum Aç
              </Typography>
              {loading && (
                <CircularProgress
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mt: 2,
                    mb: 2,
                  }}
                />
              )}
              <Box
                component="form"
                noValidate
                onSubmit={formik.handleSubmit}
                sx={{ mt: 1 }}
              >
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label="Email Adresi"
                  name="email"
                  autoComplete="email"
                  autoFocus
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.email && Boolean(formik.errors.email)}
                  helperText={formik.touched.email && formik.errors.email}
                />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label="Parola"
                  type="password"
                  id="password"
                  autoComplete="current-password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.password && Boolean(formik.errors.password)
                  }
                  helperText={formik.touched.password && formik.errors.password}
                />
                <FormControlLabel
                  control={<Checkbox value="remember" color="primary" />}
                  label="Beni hatırla"
                />
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2 }}
                >
                  Oturumu Aç
                </Button>
                {message && (
                  <Alert severity={message.type}>
                    <AlertTitle>Bilgi</AlertTitle>
                    <strong>{message.message}</strong>
                  </Alert>
                )}
                <Grid container>
                  <Grid item xs>
                    <Link href="/forgotpassword" variant="body2">
                      Parolamı unuttum
                    </Link>
                  </Grid>
                  <Grid item>
                    <Link href="/signup" variant="body2">
                      {'Hesabınız yok mu? Kayıt olun'}
                    </Link>
                  </Grid>
                </Grid>
                <Copyright sx={{ mt: 10 }} />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </div>
    </ThemeProvider>
  );
};

export default SignInPage;
